<template>
	<section class="section saved-resources">
		<div class="container mx-auto">

      <search-sort :modelValue="searchSortData" :sortMenu="sortMenu" placeholder="Search Resources"></search-sort>

      <!-- TODO: Search Resources -->
      <!-- <div class="resource-cards">
        <template v-for="(result,r) in results" :key="r">
          <block-resource-card :payload="result"></block-resource-card>
        </template>
      </div> -->

      <!-- Latest News -->
      <!-- <div class="latest-news">
        <div class="latest-news__intro" style="background-image: url('https://images.unsplash.com/photo-1536607961765-592e80bcc19e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')">
          <div class="latest-news__intro-content">
            <h2 class="latest-news__title">Latest News from escape</h2>
            <p>Free monthly meetups and walks. Chat to fellow escapees and have a chilled walk.</p>
            <a class="latest-news__btn" href="#">More Info (TODO: link)</a>
          </div>
        </div>
        <block-latest-news-resources></block-latest-news-resources>
      </div> -->

      <slot></slot>

		</div>
	</section>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';
  import SearchSort from './partials/SearchSort';

	export default {
		name: 'SavedResources',

    mixins: [AuthMixins],

    components: {
      SearchSort
    },

    data() {
    	return  {
        results: false,
        searchSortData: {search:'', sort:'title_asc'},
        sortMenu: [
          { title: 'Title Ascending', value: 'title_asc', selected: false },
          { title: 'Title Descending', value: 'title_desc', selected: false },
          { title: 'Newest First', value: 'date_desc', selected: false },
          { title: 'Oldest First', value: 'date_asc', selected: false }
        ]
    	}
    },

		created() {

		},

		beforeUnmount() {

		},

    methods: {
      refreshFilters() {
        switch (this.searchSortData.sort) {
          case 'title_asc':
          this.results.sort((a, b) => a['job-title'].toLowerCase().localeCompare(b['job-title'].toLowerCase()));
            break;
          case 'title_desc':
          this.results.sort((a, b) => b['job-title'].toLowerCase().localeCompare(a['job-title'].toLowerCase()));
            break;
          case 'date_asc':
          this.results.sort((a, b) => a['posted-date'] - b['posted-date']);
            break;
          case 'date_desc':
          this.results.sort((a, b) => b['posted-date'] - a['posted-date']);
            break;
        }
      }
    },

		computed: {
      computedFliteredResources() {
        return this.results.filter(v => {
          return v['job-title'].toLowerCase().includes(this.searchSortData.search.toLowerCase());
        });
      }
    },

    watch: {
    	searchSortData: {
        deep:true,
        handler() {
          this.refreshFilters();
        }
      }
    }
	}
</script>
